import { wrapperBuilder } from './build';
const variables = wrapperBuilder.getVariablesRegisterInstance();

variables.addVariable('envelopes', { startValue: undefined });
